// Locale-aware absolute-date formatting (non-currency display primitive).
//
// Companion to `format-count` / `format-number`: keeps `Intl.DateTimeFormat`
// construction out of component render bodies. Per-locale instances are cached
// in a Map so the formatter — and its output identity — stay stable across
// renders for a given locale.

const DEFAULT_LOCALE = 'en-US';

const shortDateByLocale: Map<string, Intl.DateTimeFormat> = new Map<string, Intl.DateTimeFormat>();
const dateTimeByLocale: Map<string, Intl.DateTimeFormat> = new Map<string, Intl.DateTimeFormat>();

/** Format in the viewer's local timezone, reusing one formatter per locale. */
export function formatLocalDateTime(date: number | Date, locale: string): string {
  let formatter = dateTimeByLocale.get(locale);
  if (formatter === undefined) {
    formatter = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' });
    dateTimeByLocale.set(locale, formatter);
  }
  return formatter.format(date);
}

/** Format a date/timestamp as a localized "MMM d" date (e.g. `"Mar 5"` / `"5 mars"`). */
export function formatShortDate(date: number | Date, locale: string = DEFAULT_LOCALE): string {
  let fmt = shortDateByLocale.get(locale);
  if (fmt === undefined) {
    fmt = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
    shortDateByLocale.set(locale, fmt);
  }
  return fmt.format(date);
}
